export const LOGIN_URL = 'oauth/token';
export const INFO_USER = 'oauth/info';
export const PERMISSIONS_USER = 'oauth/permissions';
